import React from 'react'

import classes from './StartingModalMessage.css';

const StartingModalMessage = (props) => {
    return (
        <div className={classes.StartingModalMessage}>
            <div className={classes.About}>
                <h3>Here's How It Works:</h3>
                <hr></hr>
                <p>1 submission per person (per IP)</p>
                <p>When a form closes the names submitted will be shuffled in a random manner
                    (This shuffling process will take place a random number of times to really get the list mixed up!)
                </p>
                <p>Once the dust settles, The winners will be selected off the top of the list!</p>                
                <p>Those winners will be sent a PayPal money request which must be paid right away</p>
                <div className={classes.EmailListSection}>
                    <p className={classes.TextLine}>Please feel free to </p> 
                    <p className={classes.EmailListLink} onClick={props.clicked}>join our email list</p>
                    <p className={classes.TextLine}> for exclusive email only drops, sneak
                        peeks, product beta testing, and more!</p>
                </div>
                    
                <hr></hr>
                <h1 className={classes.BestWishes}>GoodLuck!</h1>
            </div>
            
        </div>
    )
}

export default StartingModalMessage;


// WEBPACK FOOTER //
// ./src/components/UI/Modal/StartingModalMessage/StartingModalMessage.js